var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.localMode)?_c('div',{staticClass:"alert alert-warning text-center mb-0",attrs:{"role":"status"}},[_vm._v("LOCAL DEVELOPMENT · "+_vm._s(_vm.dataLabel)+" · "+_vm._s(_vm.stripeLabel)+" · Email delivery disabled")]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }